import React, { Component } from "react";
import crypto from "crypto";
import data from "./api";
import { store } from "react-notifications-component";
import "./App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import logo from "./images/images/earthid-logo.png"
import Swal from 'sweetalert2';
import ReactDOMServer from 'react-dom/server';
import { credentials } from './properties';

const {
  listenForUserData,
  listenForServiceProviderResponse,
  generateQrCodeNest,
  registerVendor,
} = data;

let showNotification = true;

class Navbar extends Component {
  state = {
    showSpinner: false,
    showBtn: true,
    requestNo: "",
    qrcode: false,
    response: false,
    btnText: "Login with EarthID",
    showText: true,
    showModal: true,
    modalHeading: false,
  };


  userDenied = () => {
    this.setState({
        response: false,
        showModal: false,
    });
    setTimeout(() => {
        document.getElementById("exampleModalLogin").click();
        if (showNotification === true) {
            showNotification = false;
            store.addNotification({
                title: "Error!",
                message: `User Didn't Authorize!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 3000,
                    onScreen: true,
                },
            });
        }
    }, 0);
};


updateNotificationState = () => {
    setTimeout(() => {
        showNotification = true;
    }, 100);
    this.redirectToGenerateCred();
};



listenForSocket = () => {
    listenForServiceProviderResponse((err, res) => {
      // console.log("nikhil", res);
        this.setState({
            qrcode: false,
            response: false,
            showSpinner: true,
            showText: false,
        });
    });

  listenForUserData(async (err, res) => {
        let bytes = res.userDetails || res.newreq;
        
        // Save bytes data to sessionStorage
  sessionStorage.setItem('profileData', JSON.stringify(bytes));
console.log('Got Session Data')
        this.setState({
            showQr: false,
            showSpinner: false,
        });
        let creditnals;
        let sessionKey;
        if (bytes === "denied" || bytes.permission === "denied") {
            this.userDenied();
        } else if(
            bytes.permission === "granted" ||
            bytes === "issuerLogin" ||
            bytes === "credentialsgenerated" ||
            bytes === "verifylogin" ||
            bytes === "success"
        ) {
            this.setState({
                response: true,
                showSpinner: false,
                loggedIn: true,
                showModal: false,
                btnText: "LogOut",
                bytes: "issuerLogin",
            });
            setTimeout(() => {
                document.getElementById("exampleModalLogin").click();
                let popMessage;
                if (showNotification === true) {
                    if (this.state.bytes === "credentialsgenerated") {
                        popMessage = "Credentials Generated";
                    } else {
                        popMessage = `Login Successful`;
                    }
                    showNotification = false;
                    store.addNotification({
                        title: "Success!",
                        message: popMessage,
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 3000,
                            onScreen: true,
                        },
                    });
                    if (bytes.permission === "granted") {
                        this.updateNotificationState();
                    }
                }
            }, 0);
        }  else {
            this.setState({
                response: false,
                showModal: false,
            });
            setTimeout(() => {
                document.getElementById("exampleModalLogin").click();
                if (showNotification === true) {
                    showNotification = false;
                    store.addNotification({
                        title: "Error!",
                        message: `User Didn't Authorize!`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 3000,
                            onScreen: true,
                        },
                    });
                }
            }, 0);
        }
    });
};



generateQrCodeData = async () => {

    registerVendor()
        .then((d) => {
            const timestamp = Date.now();
            const hash = crypto
                .createHmac("sha256", d.secretKey)
                .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
                .digest("hex");
                console.log("Hash", hash)
            generateQrCodeNest(hash, d.apiKey, "Rejolut@1008", timestamp, "login")
                .then((data) => {
                    this.listenForSocket();
                    this.setState({
                        showQr: true,
                        qrCodeData: data,
                        apiKey: this.state.apikey,
                        qrcode: false,
                    });
                })
                .catch((err) => {
                    alert(err);
                });
        })
        .catch((err) => {
            alert(err);
        });
};

//Admin functions


adminNotificationState = () => {
  setTimeout(() => {
      showNotification = true;
  }, 100);
  this.redirectToAdmin();
};


redirectToAdmin() {
  window.location.href = "/admin-age";
}

listenForSocketAdmin = () => {
  listenForServiceProviderResponse((err, res) => {
    // console.log("nikhil", res);
      this.setState({
          qrcode: false,
          response: false,
          showSpinner: true,
          showText: false,
      });
  });

listenForUserData(async (err, res) => {
      let bytes = res.userDetails || res.newreq;
      console.log("bytes", bytes);
      this.setState({
          showQr: false,
          showSpinner: false,
      });
      let creditnals;
      let sessionKey;
      if (bytes === "denied" || bytes.permission === "denied") {
          this.userDenied();
      } else if (
          bytes.permission === "granted" ||
          bytes === "issuerLogin" ||
          bytes === "credentialsgenerated" ||
          bytes === "verifylogin" ||
          bytes === "success"
      ) {
          this.setState({
              response: true,
              showSpinner: false,
              loggedIn: true,
              showModal: false,
              btnText: "LogOut",
              bytes: "issuerLogin",
          });
          setTimeout(() => {
              document.getElementById("exampleModalLogin").click();
              let popMessage;
              if (showNotification === true) {
                  if (this.state.bytes === "credentialsgenerated") {
                      popMessage = "Credentials Generated";
                  } else {
                      popMessage = `Login Successful`;
                  }
                  showNotification = false;
                  store.addNotification({
                      title: "Success!",
                      message: popMessage,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                          duration: 3000,
                          onScreen: true,
                      },
                  });
                  if (bytes.permission === "granted") {
                      this.adminNotificationState();
                  } else if (bytes === "verifylogin") {
                      this.verifyNotificationState();
                  }
              }
          }, 0);
      } else {
          this.setState({
              response: false,
              showModal: false,
          });
          setTimeout(() => {
              document.getElementById("exampleModalLogin").click();
              if (showNotification === true) {
                  showNotification = false;
                  store.addNotification({
                      title: "Error!",
                      message: `User Didn't Authorize!`,
                      type: "danger",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animated", "fadeIn"],
                      animationOut: ["animated", "fadeOut"],
                      dismiss: {
                          duration: 3000,
                          onScreen: true,
                      },
                  });
              }
          }, 0);
      }
  });
};

generateQrCodeDataAdmin = async () => {

  registerVendor()
      .then((d) => {
          const timestamp = Date.now();
          const hash = crypto
              .createHmac("sha256", d.secretKey)
              .update(JSON.stringify(d.apiKey + "Rejolut@1008" + timestamp))
              .digest("hex");
          generateQrCodeNest(hash, d.apiKey, "Rejolut@1008", timestamp, "login")
              .then((data) => {
                  this.listenForSocketAdmin();
                  this.setState({
                      showQr: true,
                      qrCodeData: data,
                      apiKey: this.state.apikey,
                      qrcode: false,
                  });
              })
              .catch((err) => {
                  alert(err);
              });
      })
      .catch((err) => {
          alert(err);
      });
};

//Admin Functions end

qrcode = () => {
    let { qrCodeData } = this.state;
    return (
        <div className="qr-container">
            <img src={qrCodeData} alt="new" />
        </div>
    );
};

redirectToHome() {
    window.location.href = "/";
}
redirectToGenerateCred() {
    window.location.href = "/generateCred";
}

 showLoginPopup(userType) {
  const popupContent = (
    <div>
      <input type="text" id="username" className="swal2-input" placeholder="Username" />
      <input type="password" id="password" className="swal2-input" placeholder="Password" />
    </div>
  );

  Swal.fire({
    title: 'Login with Credentials',
    html: ReactDOMServer.renderToStaticMarkup(popupContent),
    showCancelButton: true,
    confirmButtonText: 'Login',
    preConfirm: () => {
      const username = Swal.getPopup().querySelector('#username').value;
      const password = Swal.getPopup().querySelector('#password').value;

      const userList = credentials[userType] || [];

      const isValid = userList.some(
        (cred) => cred.username === username && cred.password === password
      );

      if (isValid) {
        window.location.href = userType === 'customer' ? '/user' : '/admin-age';
      } else {
        Swal.showValidationMessage('Invalid username or password');
      }
    },
  });
}



  render() {
    let showButton = this.state.showSpinner ? (
      <div className="spinner-div">
        <img className="spinner" src={require("./spinner.gif")} />
      </div>
    ) : null;
    return (
      <div className="App">

{window.location.pathname == "/" ? (
               
<div className='dropdown nav-buttonsnew-dd'>
                                    <button
                                        className='nav-buttonsnew dropdown-toggle'
                                        type='button'
                                        id='certificateDropdown'
                                        data-toggle='dropdown'
                                        aria-haspopup='true'
                                        aria-expanded='false'
                                        style={{ marginRight: "2rem", marginLeft: "2rem" }}
                                    >
                                        {'Admin Login'}
                                    </button>
                                    <div 
                                    className='dropdown-menu dropdown-menu-right' 
                                    aria-labelledby='certificateDropdown'
                                    style={{ width: "210px"}}
                                    >
                                    <a
                                            className='dropdown-item'
                                            onClick={() => this.showLoginPopup('admin')}
                                            style={{ cursor: "pointer" }}
                                        >
                                            Login with Credentials
                                        </a>
                                        <a
                                            className='dropdown-item'
                                            data-toggle="modal"
                    data-target="#exampleModalLogin"
                    style={{ cursor: "pointer" }}
                                            onClick={this.state.btnText=="LogOut"?this.redirectToHome:this.generateQrCodeDataAdmin}
                                        >
                                            Login with EarthID
                                        </a>
                                        
                                        
                                    </div>
                                </div>
): (
  <div>

  </div>
)}

          <div className="modal_container" id="modal-container">
            <div className="modal">
              <div className="qr-code">
                <img
                  src='https://api.qrserver.com/v1/create-qr-code/?data={"apikey":"UKURGTREFATPSYJ","reqNo":"BAZQUVRDTLF","sessionKey":"BAZQUVRDTLF","requestType":"login","encryptionkey":"loginDetailsEncryption" }'
                  alt="QR-Code"
                />
              </div>

              <button id="btn-close">Close me</button>
            </div>
          </div>

          <div className="hero-section">
          <div className="shoppingCart"></div>
          <div
            className="modal fade"
            id="exampleModalLogin"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              {
                <div>
                  {this.state.showModal ? (
                    <div className="modal-content">
                      <div className="close-button-containerr">
                      <h4 style={{ color: "black" }}>
                          {/* {this.state.modalHeading && !this.state.showSpinner
                            ? "Use Earth ID app to scan the QR code"
                            : "Waiting for user authorization"} */}
                             Scan me using your wallet
                        </h4>
    <FontAwesomeIcon className="close-buttonn" data-dismiss="modal"  icon={faClose} />
 
</div>
                        
                        
                      
                      <div className="modal-body">
                        <div className="pop-upbox">
                          {showButton}
                          {this.state.response
                            ? null
                            : this.state.qrcode
                              ? this.generateQrCodeData()
                              : null}
                          {this.state.showQr ? (
                            this.qrcode()
                          ) : this.state.showSpinner ? (
                            <img
                              className="spinner"
                              src={require("./spinner.gif")}
                            />
                          ) : null}
                        </div>
                      </div>
                      
                        {/* <button
                          type="button"
                          className="btn btn-secondary p-btn"
                          data-dismiss="modal"
                        >
                          Close
                        </button> */}
                    </div>
                  ) : null}
                </div>
              }
            </div>
          </div>
        </div>
     
      
      
      
      </div>
    );
  }
}

export default Navbar;